import useMutation from "src/hooks/useMutation";

function useOrderScan(id) {
  return useMutation({
    path: `/api/v1/orders/${id}/process`,
    method: "POST",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/orders/${id}`,
      shouldRevalidate: true,
    },
  });
}

export default useOrderScan;
